







import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const indexModule = namespace("index");

@Component
export default class Main extends Vue {
  goAccount() {
    this.$router.push("/mine/shop/account");
  }
  goReset() {
    this.$router.push("/mine/shop/modify");
  }
}
